import * as React from 'react'

import { Image } from '@thg-commerce/gravity-elements/Image'
import { ImageProps } from '@thg-commerce/gravity-elements/Image/Image'
import { DrawFocus } from '@thg-commerce/gravity-elements/mixin/focus'
import { styled, spacing, Text, mq } from '@thg-commerce/gravity-theme'

export interface LinkCardProps {
  displayMode?: 'plain' | 'background'
  image: Omit<ImageProps, 'isAmp'>
  name: string
  link: string
  isAmp: boolean
}

const Title = styled.div<{ displayMode: 'plain' | 'background' | undefined }>`
  ${Text('bodyText', 'default')};
  display: flex;
  flex-grow: 1;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: ${spacing(2)};
  text-align: center;

  ${(props) => mq(props.theme.breakpointUtils.map, 'sm')} {
    padding: ${spacing(3)};
  }

  ${(props) =>
    props.displayMode === 'plain'
      ? `
    border: solid 1px ${props.theme.colors.palette.brand.dark};
    border-top: 0;
  `
      : props.displayMode === 'background'
      ? `
    background-color: ${props.theme.colors.palette.brand.dark};
    color: ${props.theme.colors.palette.greys.white};
`
      : `
    border: solid 1px ${props.theme.colors.palette.brand.dark};
    border-top: 0;
  `}
`

const StyledLink = styled.a`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  text-decoration: none;

  &:hover ${Title} {
    text-decoration: underline;
  }

  ${DrawFocus()}
`

export const LinkCard = React.memo((props: LinkCardProps) => {
  return (
    <StyledLink href={props.link} data-testid="link-card">
      <Image
        src={props.image.src}
        width="100%"
        height="auto"
        alt={props.image.alt || ''}
        isAmp={props.isAmp}
      />
      <Title displayMode={props.displayMode} data-testid="link-title">
        {props.name}
      </Title>
    </StyledLink>
  )
})
